import Exception from 'app/errors/exception';

export default class UnexpectedValueException extends Exception
{
}
